<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div :class="['table-price', { 'table-price_no-padding': noPadding }]">
    <div
      v-for="(row, index) in getRows"
      v-if="row.value || row.label"
      :key="`table-price-${_uid}-row-${index}`"
    >
      <template v-if="index === 2 && checkOptionalMaterials">
        <div class="table-price__row">
          <div class="table-price__label">
            <span class="h4 subtitle">
              {{ optionalMaterials.title }}
            </span>
          </div>
        </div>

        <div
          v-for="(optRow, optRowIndex) in getOptionalRows"
          :key="`table-price-${_uid}-optionalMaterials-row-${optRowIndex}`"
          class="table-price__row table-price__row_optional-materials"
        >
          <div
            v-for="(optCol, optColIndex) in optRow"
            :key="`table-price-${_uid}-optionalMaterials-row-${optRowIndex}-${optColIndex}`"
            class="table-price__col"
          >
            <template v-if="optCol.list">
              {{ optCol.text }}
              <BaseHint v-if="optCol.hint" :hintText="optCol.hint" />
              <BaseSelect
                scrollbar="none"
                class="table-price__col-select"
                :items="Object.values(optCol.list).map(item => ({ text: item.label, value: item.id }))"
                @input="onOptionalMaterialChange($event, optCol)"
              />
            </template>
            <template v-else>{{ optCol.text }}</template>
          </div>
        </div>
      </template>

      <div
        :class="[
          'table-price__row',
          { 'table-price__row_last': index === getRows.length - 1 },
          { 'table-price__row_last-penultimate': index === getRows.length - 2 },
          { 'table-price__hasSubrow': row.subRows },
        ]"
      >
        <div class="table-price__label">
          <h4 v-if="index === getRows.length - 1" class="table-price__label-text">
            {{ row.label }}
          </h4>
          <span v-else class="subtitle h4">
            {{ row.label }}
          </span>
          <BaseHint
            v-if="row.hint"
            :options="{ ...tooltipOptions }"
            :hintText="row.hint"
            placementCenter
          />
        </div>
        <h4
          v-if="index === getRows.length - 1"
          class="table-price__value table-price__summ"
        >
          {{ row.value }}
        </h4>
        <div v-else class="table-price__value subtitle">{{ row.value }}</div>
      </div>
      <div class="table-price__subRow" v-for="subRow in row.subRows">
        <div class="table-price__label">
          <span class="table-price__label-text">
            {{ subRow.label }}
          </span>
        </div>
        <div class="table-price__value">{{ subRow.value }}</div>
      </div>

      {{ getRows.items }}
      <div v-if="index === 4" class="addWorkPackageList">
        <div
          v-for="item in row.items"
          :key="`list-table-price-packages-${_uid}-row-${index}`"
        >
          <span>{{ item.label }} </span>
          <span>
            {{ item.cost }}
          </span>
        </div>
      </div>
      <div v-if="index === 4" class="addWorkPackage">
        <TableAddWorkPackage :rows="addWorkPackage" :excludePackageMessage="excludePackageMessage" />
      </div>
    </div>
    <div v-if="warning" class="table-price__warning support-text">
      <Asterisk class="table-price__warning-asterisk" />
      {{ warning }}
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'

  import Asterisk from '@/assets/img/icons/asterisk.svg?inline'
  import TableAddWorkPackage from './TableAddWorkPackage.vue'

  export default {
    name: 'TablePrice',
    components: {
      Asterisk,
      TableAddWorkPackage
    },
    mixins: [clickaway],
    props: {
      excludePackageMessage: {
        type: String
      },
      warning: {
        type: String,
        default: ''
      },
      optionalMaterials: {
        type: Object
      },
      materials: {
        type: Object
      },
      addWorkPackage: {
        type: Array
      },
      rows: {
        type: Array,
        required: true,
        validator (rows) {
          return rows.every(row => {
            return 'label' in row && 'value' in row
          })
        }
      },
      noPadding: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        tooltipOptions: {
          offset: 13,
          classes: ['info'],
          targetClasses: ['it-has-a-tooltip'],
          delay: {
            show: 100,
            hide: 100
          }
        }
      }
    },
    computed: {
      getRows () {
        if (
          (this.rows[4].items && this.rows[4].items.length) ||
          (this.addWorkPackage && this.addWorkPackage.length)) {
          return this.rows
        } else {
          return this.rows.filter((item, index) => {
            return index < 4
          })
        }
      },
      checkOptionalMaterials () {
        return !!(this.optionalMaterials && this.optionalMaterials.rows && this.optionalMaterials.rows.length)
      },
      getOptionalRows () {
        if (this.checkOptionalMaterials) {
          return this.optionalMaterials.rows.filter(item => item['col-1'].list)
        }
        return []
      }
    },
    methods: {
      onOptionalMaterialChange (event, col) {
        const index = this.materials.rows.findIndex(row => {
          return row['col-1'].position && row['col-1'].position === col.position
        })
        this.$emit('oilChange', event, index)
      }
    }
  }
</script>

<style lang="scss">
.addWorkPackageList {
  margin-top: -10px;
  @media (max-width: 767px) {
    margin-top: -12px;
  }
  .table-price__value {
    text-wrap: nowrap;
    align-self: center;
  }
  div {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 20px;
    color: $c-gray-dark;

    span:last-child {
      @include mobile {
        display: inline;
        min-width: 35%;
        text-align: center;
      }
    }

    span {
      font-size: 14px;
      color: #a8aaac;

      @include mobile {
        font-size: 14px;
      }
    }

    &:last-child {
      margin: 0;
    }

    @include tablet {
      margin-bottom: 20px;
    }

    @include mobile {
      margin-bottom: 20px;
    }
  }
}

.table-price {
  padding: 60px;
  background: $c-gray-light;

  @include tablet {
    padding: 60px 40px;
  }

  @include mobile {
    padding: 30px 25px;
  }

  &__warning {
    position: relative;
    padding-left: 14px;
    margin-top: 30px;
    font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
    color: rgba($c-black, 0.4);

    @include mobile {
      margin-top: 28px;
    }

    &-asterisk {
      position: absolute;
      top: 0;
      left: 3px;
    }
  }

  &__label {
    position: relative;
    display: flex;
    align-items: center;
    font-family: "FavoritBookC", Arial, Helvetica, sans-serif;

    @include mobile {
      max-width: 155px;
    }

    &-text {
      font-family: "FavoritC", Arial, Helvetica, sans-serif;
      color: $c-gray-dark;

      @include mobile {
        font-size: 18px;
        line-height: 26px;
        text-align: left;
      }
    }

    .base-hint {
      position: absolute;
      top: 0;
      right: -40px;
      height: 28px;

      @include mobile {
        top: 50%;
        right: -35px;
        transform: translateY(-50%);
      }
    }
  }

  &__value {
    font-family: "FavoritC", Arial, Helvetica, sans-serif;
    color: inherit;
    text-align: right;

    @include mobile {
      width: 35%;
    }

    @include mobileXs {
      width: 40%;
    }
  }

  &__summ {
    @include mobile {
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0.08px;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    color: $c-gray-dark;

    @include tablet {
      margin-bottom: 30px;
    }

    @include mobile {
      margin-bottom: 20px;
    }

    &_last {
      position: relative;
      // align-items: flex-start;
      padding-top: 40px;
      margin-bottom: 0;
      color: $c-black;

      @include mobile {
        padding-top: 30px;
      }

      &::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        content: "";
        background: rgba($c-black, 0.22);
      }

      .table-price__label {
        @include mobile {
          max-width: 110px;
        }
      }

      &-penultimate {
        @include tablet {
          margin-bottom: 40px;
        }

        @include mobile {
          margin-bottom: 30px;
        }
      }
    }

    &_optional-materials {
      justify-content: flex-start;
      column-gap: 48px;

      @include tablet {
        column-gap: 24px;
      }

      @include mobile {
        row-gap: 12px;
        justify-content: flex-end;
        flex-wrap: wrap;
      }
    }

    &.table-price__hasSubrow {
      margin-bottom: 12px;
    }
  }

  &__subRow {
    padding-left: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    color: $c-black;
    @include mobile {
      padding-left: 12px;
    }

    .table-price__label-text {
      font-family: "FavoritBookC", sans-serif;
      font-weight: 400;
      font-size: 18px;
      color: $c-black;
      //font-size: 14px;
      @include mobile {
        font-size: 14px;
        line-height: 19px;
      }
    }

    .table-price__value {
      font-family: "FavoritBookC", sans-serif;
      font-weight: 400;
      font-size: 18px;
      //font-size: 14px;
      @include mobile {
        font-size: 14px;
        line-height: 19px;
      }
    }

    &:last-of-type {
      margin-bottom: 16px;
    }
  }

  &__col {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 48px;
    flex-shrink: 0;
    min-width: 56px;
    font-size: 18px;
    line-height: 24px;

    @include tablet {
      column-gap: 24px;
    }

    @include mobile {
      font-size: 15px;
    }

    &:first-child {
      flex-grow: 1;

      @include mobile {
        width: 100%;
        column-gap: 12px;
      }
    }

    &:last-child {
      min-width: 84px;
      justify-content: flex-end;
    }

    &-select {
      min-width: 220px;
      padding-bottom: 0;
      margin-right: 48px;

      @include tablet {
        min-width: 200px;
        margin-right: 24px;
      }

      @include mobile {
        width: 50%;
        min-width: 180px;
        margin-right: 0;
      }

      .select__dropdown {
        top: 100%;
      }
    }
  }

  &_no-padding {
    padding: 0;

    .table-price__row:last-child::before {
      left: 0;
      width: 100%;
    }
  }
}
</style>
